import { inject } from '@angular/core';
import { AuthService } from '../services';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

export const FitterXGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.userIsFitter$().pipe(
    map((IsFitterX) => {
      return IsFitterX ? true : router.parseUrl('/login');
    })
  );
};
